<template>
    <table class="table table-striped b-warehouse__table">
        <thead>
            <tr>
                <th class="col-xs-3" v-text="trans('grade')" style="text-align: left; vertical-align: middle"></th>
                <th class="col-xs-9">
                    <table class="b-warehouse__variants-table">
                        <tbody>
                            <tr>
                                <td class="col-xs-1 text-left" v-text="trans('pack')"></td>
                                <td class="col-xs-1 text-left" v-text="trans('available_quantity')"></td>
                                <td class="col-xs-1 text-left" v-text="trans('reserve')"></td>
                                <td class="col-xs-1 text-left" v-text="trans('total_quantity')"></td>
                                <td class="col-xs-2 text-left" v-text="trans('average_purchase_price')"></td>
                                <td class="col-xs-2 text-left" v-text="trans('total_purchase_price')"></td>
                                <td class="col-xs-2 text-left" v-text="trans('new_quantity')"></td>
                                <td class="col-xs-2 text-left" v-text="trans('comment')"></td>
                            </tr>
                        </tbody>
                    </table>
                </th>
            </tr>
        </thead>
        <tbody>
        <tr v-for="product in loaded_brand.products" :id="'product-' + product.id">
            <td>
                <span class="b-warehouse__product-name" :data-product="product.id">
                    {{ product.name }}
                </span>
            </td>
            <td>
                <table class="b-warehouse__variants-table">
                    <tbody>
                    <tr v-for="variant in product.variants">
                        <td class="col-xs-1">{{ variant.title }}</td>
                        <!-- Резерв -->
                        <td class="col-xs-1">
                            <span>{{ variant.available_quantity }}</span>
                            <input type="hidden" :name="'data[' + variant.id + '][available_quantity]'" :value="variant.available_quantity">
                        </td>
                        <!-- Резерв -->
                        <td class="col-xs-1">
                            <span>{{ variant_reserves[variant.id] }}</span>
                            <input type="hidden" :name="'data[' + variant.id + '][reserve]'" :value="variant_reserves[variant.id]">
                        </td>
                        <!-- Общее количество -->
                        <td class="col-xs-1">
                            <span>{{ variant.available_quantity + variant_reserves[variant.id] }}</span>
                            <input type="hidden" :name="'data[' + variant.id + '][old_total_quantity]'" :value="variant.available_quantity + variant_reserves[variant.id]">
                        </td>
                        <!-- Средняя закупочная цена -->
                        <td class="col-xs-2">
                            <input class="form-control input-sm b-warehouse__new-count" type="number" min="0" step="0.0001" :name="'data[' + variant.id + '][new_average_purchase_price]'" :value="variant.average_purchase_price">
                            <input class="form-control input-sm b-warehouse__new-count" type="hidden" :name="'data[' + variant.id + '][old_average_purchase_price]'" :value="variant.average_purchase_price">
                        </td>
                        <!-- Общая стоимость -->
                        <td class="col-xs-2">
                            {{ variant_total_prices[variant.id] }}
                        </td>
                        <!-- Новое введенное количество -->
                        <td class="col-xs-2">
                            <input class="form-control input-sm b-warehouse__new-count" type="number" min="0" step="1" :name="'data[' + variant.id + '][new_total_quantity]'" :value="variant.available_quantity + variant_reserves[variant.id]">
                        </td>
                        <!-- Комментарий -->
                        <td class="col-xs-2">
                            <input class =" form-control input-sm b-warehouse__new-count" type = "text" placeholder = "Комментарий" tabindex="-1" :name="'data[' + variant.id + '][comment]'">
                        </td>
                    </tr>
                    </tbody>
                </table>
            </td>
        </tr>
        </tbody>
    </table>
</template>

<script>
let Functions = require("../../Functions");

module.exports = {
    props: ['loaded_brand', 'variant_reserves', 'translations', 'variant_total_prices'],
    methods: {
        trans(name, path = 'stock') {
            return Functions.trans(this.translations, name, path);
        }
    },
};
</script>
